import { camelCaseObject } from '@edx/frontend-platform';
import { logError, logInfo } from '@edx/frontend-platform/logging';
import { call, put, takeEvery } from 'redux-saga/effects';

import {
  fetchRealtimeValidationsBegin,
  fetchRealtimeValidationsFailure,
  fetchRealtimeValidationsSuccess,
  GET_MARKETABLE_PREFERENCE,
  getMarketablePreferenceBegin,
  getMarketablePreferenceFailure,
  getMarketablePreferenceSuccess,
  REGISTER_FORM_VALIDATIONS,
  REGISTER_NEW_USER,
  registerNewUserBegin,
  registerNewUserFailure,
  registerNewUserSuccess,
  UPDATE_MARKETABLE_PREFERENCE,
  updateMarketablePreferenceBegin,
  updateMarketablePreferenceFailure,
  updateMarketablePreferenceSuccess,
} from './actions';
import { INTERNAL_SERVER_ERROR } from './constants';
import {
  getFieldsValidations,
  getMarketingPreference,
  registerRequest,
  updateMarketingPreference,
} from './service';

export function* handleNewUserRegistration(action) {
  try {
    yield put(registerNewUserBegin());

    const { authenticatedUser, redirectUrl, success } = yield call(registerRequest, action.payload.registrationInfo);

    yield put(registerNewUserSuccess(
      camelCaseObject(authenticatedUser),
      redirectUrl,
      success,
    ));
  } catch (e) {
    const statusCodes = [400, 403, 409];
    if (e.response && statusCodes.includes(e.response.status)) {
      yield put(registerNewUserFailure(camelCaseObject(e.response.data)));
      logInfo(e);
    } else {
      yield put(registerNewUserFailure({ errorCode: INTERNAL_SERVER_ERROR }));
      logError(e);
    }
  }
}

export function* fetchRealtimeValidations(action) {
  try {
    yield put(fetchRealtimeValidationsBegin());
    const { fieldValidations } = yield call(getFieldsValidations, action.payload.formPayload);
    yield put(fetchRealtimeValidationsSuccess(camelCaseObject(fieldValidations)));
  } catch (e) {
    if (e.response && e.response.status === 403) {
      yield put(fetchRealtimeValidationsFailure());
      logInfo(e);
    } else {
      logError(e);
    }
  }
}

export function* fetchMarketablePreference() {
  try {
    yield put(getMarketablePreferenceBegin());
    const data = yield call(getMarketingPreference);
    yield put(getMarketablePreferenceSuccess(data.is_marketable || false));
  } catch (e) {
    yield put(getMarketablePreferenceFailure());
  }
}

export function* updateMarketablePreference(action) {
  try {
    yield put(updateMarketablePreferenceBegin(action.payload));
    yield call(updateMarketingPreference, action.payload);
    yield put(updateMarketablePreferenceSuccess());
  } catch (e) {
    yield put(updateMarketablePreferenceFailure());
  }
}

export default function* saga() {
  yield takeEvery(REGISTER_NEW_USER.BASE, handleNewUserRegistration);
  yield takeEvery(REGISTER_FORM_VALIDATIONS.BASE, fetchRealtimeValidations);
  yield takeEvery(GET_MARKETABLE_PREFERENCE.BASE, fetchMarketablePreference);
  yield takeEvery(UPDATE_MARKETABLE_PREFERENCE.BASE, updateMarketablePreference);
}
